import React from 'react';
import { useMessage } from '../messages/useMessage';
import { useManageClassService } from '../services/manage-class-service';

export const useManageClassController = () => {
  const {
    createClassRoom,
    getcolumns,
    getSimpleBoardItems,
    getCompleteBoardItems,
    patchInterviewToClass,
    getClassRoomById,
    editClassRoomId
  } = useManageClassService();
  const [loading, setLoading] = React.useState(false);

  const { handleAttention } = useMessage();

  const getColumnsData = React.useCallback(
    (data) => {
      setLoading(true);
      return getcolumns(data)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getcolumns],
  );

  const linkInterviewToClassRoom = React.useCallback(
    (data) => {
      setLoading(true);
      return patchInterviewToClass(data)
        .then(() => {
          return true;
        })
        .catch((error) => {
          handleAttention(error.message);
          return false;
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [patchInterviewToClass, handleAttention],
  );

  const getCompleteItemData = React.useCallback(
    (data) => {
      setLoading(true);
      return getCompleteBoardItems(data)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getCompleteBoardItems],
  );

  const getSimpleBoardItemsData = React.useCallback(
    (data) => {
      setLoading(true);
      return getSimpleBoardItems(data)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getSimpleBoardItems],
  );

  const postCreateClassRoom = React.useCallback(
    (data) => {
      setLoading(true);
      return createClassRoom(data)
        .then((data) => data)
        .catch((error) => {
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [createClassRoom],
  );


  const getClassRoomByIdC = React.useCallback(
    (idClassRoom) => {
      setLoading(true);
      return getClassRoomById(idClassRoom)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getClassRoomById],
  );

  const editClassRoomById = React.useCallback(
    (idClassRoom, data) => {
      setLoading(true);
      return editClassRoomId(idClassRoom, data)
        .then((response) => response)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [editClassRoomId],
  );



  return {
    postCreateClassRoom,
    loading,
    getColumnsData,
    getSimpleBoardItemsData,
    getCompleteItemData,
    linkInterviewToClassRoom,
    getClassRoomByIdC,
    editClassRoomById
  };
};
